import { render, staticRenderFns } from "./Biaodi.vue?vue&type=template&id=a2f30196&scoped=true&"
import script from "./Biaodi.vue?vue&type=script&lang=js&"
export * from "./Biaodi.vue?vue&type=script&lang=js&"
import style0 from "./Biaodi.vue?vue&type=style&index=0&id=a2f30196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f30196",
  null
  
)

export default component.exports